<template>
  <div class="regra-mapeamento">
    <div class="origem-bloco">
      <div class="bloco-label">Pegue o valor de</div>
      <select class="form-control form-control-sm origem-select" v-model="regra.campo">
        <option value="">Selecione um campo</option>
        <option v-for="c in campos" :key="c.value" :value="c.value">{{ c.label }}</option>
      </select>
    </div>

    <div class="traducao-bloco">
      <div class="bloco-label">Regra de tradução</div>
      <table class="mapa-table">
        <thead>
          <tr>
            <th class="col-quando">Quando o valor for…</th>
            <th class="col-enviar">… enviar</th>
            <th class="col-acao"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(par, idx) in pares" :key="idx">
            <td>
              <input
                class="form-control form-control-sm"
                type="text"
                v-model="par.chave"
                @input="atualizarMapa"
                placeholder="ex: 1"
              />
            </td>
            <td>
              <input
                class="form-control form-control-sm"
                type="text"
                v-model="par.valor"
                @input="atualizarMapa"
                placeholder="ex: PF"
              />
            </td>
            <td>
              <button
                type="button"
                class="btn-mini btn-mini--danger"
                v-if="pares.length > 1"
                @click="remover(idx)"
                title="Remover"
              >
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" class="btn-add-inline" @click="adicionar">
        <fa-icon icon="plus" /> Adicionar tradução
      </button>
    </div>

    <div class="fallback-bloco">
      <div class="fallback-label">Quando nada casar, enviar</div>
      <input
        class="form-control form-control-sm fallback-input"
        type="text"
        :value="regra.padrao"
        @input="atualizarPadrao($event.target.value)"
        placeholder="Valor padrão (vazio = nulo)"
      />
    </div>
  </div>
</template>

<script>
export const regraMapeamentoVazia = () => ({
  tipo: "mapeamento",
  campo: "",
  mapa: {},
  padrao: null,
});

export default {
  name: "RegraMapeamento",
  props: {
    value: { type: Object, required: true },
    campos: { type: Array, default: () => [] },
  },
  data() {
    return {
      pares: this.toPares(this.value.mapa || {}),
    };
  },
  computed: {
    regra() {
      return this.value;
    },
  },
  watch: {
    "value.mapa": {
      handler(novo) {
        const atualSerializado = JSON.stringify(this.toMapa(this.pares));
        if (JSON.stringify(novo || {}) !== atualSerializado) {
          this.pares = this.toPares(novo || {});
        }
      },
      deep: true,
    },
  },
  methods: {
    toPares(mapa) {
      const entries = Object.entries(mapa);
      if (entries.length === 0) return [{ chave: "", valor: "" }];
      return entries.map(([chave, valor]) => ({ chave, valor: valor === null ? "" : String(valor) }));
    },
    toMapa(pares) {
      const mapa = {};
      pares.forEach((p) => {
        if (p.chave !== "" && p.chave !== null && p.chave !== undefined) {
          mapa[p.chave] = p.valor;
        }
      });
      return mapa;
    },
    atualizarMapa() {
      this.$set(this.regra, "mapa", this.toMapa(this.pares));
      this.$emit("input", { ...this.regra });
    },
    atualizarPadrao(valor) {
      this.$set(this.regra, "padrao", valor === "" ? null : valor);
      this.$emit("input", { ...this.regra });
    },
    adicionar() {
      this.pares.push({ chave: "", valor: "" });
      this.atualizarMapa();
    },
    remover(idx) {
      this.pares.splice(idx, 1);
      this.atualizarMapa();
    },
  },
};
</script>

<style scoped>
.regra-mapeamento {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.bloco-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}
.origem-select {
  max-width: 460px;
}
.mapa-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}
.mapa-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #475467;
  background: #f8f9fa;
  text-transform: none;
  padding: 8px 10px;
  border-bottom: 1px solid #e9ecef;
}
.col-quando { width: 50%; }
.col-enviar { width: 45%; }
.col-acao { width: 5%; text-align: center; }
.mapa-table td {
  padding: 4px 8px;
  vertical-align: middle;
  border-top: 1px solid #f2f4f7;
}
.mapa-table tbody tr:first-child td {
  border-top: none;
}
.btn-add-inline {
  background: none;
  border: none;
  color: #3a3e81;
  font-size: 12px;
  padding: 4px 0;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 4px;
}
.btn-add-inline:hover {
  text-decoration: underline;
}
.btn-mini {
  background: none;
  border: none;
  cursor: pointer;
  color: #98a2b3;
  padding: 2px 6px;
  border-radius: 4px;
}
.btn-mini--danger:hover {
  color: #d92d20;
  background: #fef3f2;
}
.fallback-bloco {
  background: #fffaf0;
  border: 1px solid #fef3c7;
  border-radius: 8px;
  padding: 12px;
}
.fallback-label {
  font-size: 11px;
  font-weight: 600;
  color: #b45309;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}
.fallback-input {
  max-width: 460px;
}
</style>
